import { FormattedMessage } from "react-intl";
import Button from "./Button";
import "../styles/LandingBanner.css";

const LandingBanner = () => {
  const findNowURL = "/login",
        getiOSURL = `https://gr.trendmicro.com/GREntry/NonPayment?Target=Link&FUNID=DownloadiOSApp&PID=TMMS&Locale=${navigator.language}`,
        getAndroidURL = `https://gr.trendmicro.com/GREntry/NonPayment?Target=Link&FUNID=DownloadGooglePlay&PID=TMMS&Locale=${navigator.language}`;

  return (
    <div className="landingbanner">
      <div className="landingbanner-main-pic">
        <img src="/img/img_welcome_web.png" alt="welcome" />
      </div>
      <div className="landingbanner-main-desc">
        <div className="landingbanner-slogan">
          <h1>
            <FormattedMessage id="landing_page_title" />
          </h1>
        </div>
        <div className="landingbanner-sub-slogan">
          <FormattedMessage id="landing_page_description" values={{ br: <br/> }} />
        </div>
        <div className="landingbanner-main-button">
          <Button id="landingbanner-login" className="landingbanner-button" localeId="landing_page_finditnow" link={ findNowURL } color="red" />
        </div>
        <div className="landingbanner-download-desc">
          <FormattedMessage id="landing_page_download_from" />
        </div>
        <div className="landingbanner-download-button">
          <Button className="landingbanner-button" localeId="android" link={ getAndroidURL } color="gray" />
          <Button className="landingbanner-button" localeId="ios" link={ getiOSURL } color="gray" />
        </div>
      </div>
    </div>
  );
};

export default LandingBanner;
